/**
 *
 * Asynchronously loads the component for TimeSlotPage
 *
 */

import loadable from "@loadable/component";

export default loadable(() => import("./TimeSlotPage"));
